export { FarmFilterGroup } from '../filterTypes'

export enum KodiakFarmOrderBy {
  PoolTVL = 'poolTvl',
  Apr = 'apr',
  FarmTVL = 'farmTvl',
}

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface FarmQueryState {
  searchTerm: string
  orderBy: KodiakFarmOrderBy
  orderDirection: OrderDirection
}
